export const TEST_IDS = {
  // Generic no data patterns
  NO_DATA: 'sa-no-data',
  NO_DATA_LAST_AUCTION: 'sa-no-data-last-auction',
  NO_DATA_CHEAPEST_PRICE: 'sa-no-data-cheapest-price',
  NO_DATA_CLUB_NAME: 'sa-no-data-club-name',
  NO_DATA_LEAGUE_NAME: 'sa-no-data-league-name',
  NO_DATA_CHART: 'sa-no-data-chart',

  // No bid patterns
  NO_BID: 'sa-no-bid',
  NO_BIDS: 'sa-no-bids',

  // Price patterns
  AUCTION_PRICE: 'sa-auction-price',
  CURRENT_PRICE: 'sa-current-price',
  BEST_MARKET_PRICE: 'sa-best-market-price',
  NEXT_BID: 'sa-next-bid',

  // Component patterns
  FILTER_BUTTON: 'sa-filter-button',
  FILTER_MODAL: 'sa-filter-modal',

  // Button patterns
  BUTTON_30_PLUS: 'sa-30+-button',
  BUTTON_70_PLUS: 'sa-70+-button',
  BUTTON_RESET: 'sa-reset-button',
  BUTTON_UPDATE_SCORES: 'sa-update-scores-button',
  BUTTON_RESET_SCORES: 'sa-reset-scores-button',

  // Pagination patterns
  PAGINATION_PREV: 'sa-pagination-prev',
  PAGINATION_NEXT: 'sa-pagination-next',
  TABLE_PAGINATION: 'sa-table-pagination',

  // Score patterns
  SCORE_FRAGMENT: 'sa-score-fragment',
  SCORE_PERCENTAGE: 'sa-score-percentage',
  SCORE_FIXED: 'sa-score-fixed',
  SCORE_NAME: 'sa-score-name',
  SCORE_AVERAGE: 'sa-score-average',
  SCORE_HISTORY: 'sa-score-history',
  SCORE_ROW: 'sa-score-row',

  // Game week patterns
  GW_TILE: 'sa-gw-tile',
  GW_TITLE_TAG: 'sa-gw-title-tag',
  GW_TITLE: 'sa-gw-title',
  GW_VALUE_TAG: 'sa-gw-value-tag',
  GW_VALUE: 'sa-gw-value',
  GW_DNP: 'sa-gw-dnp',
  GW_TILES: 'sa-gw-tiles',
  GAME_WEEK_SCORES: 'sa-game-week-scores',

  // Player patterns
  PLAYER_RANK: 'sa-player-rank',
  PLAYER_LINK: 'sa-player-link',
  PLAYER_NAME_ROW: 'sa-player-name-row',
  PLAYER_NAME: 'sa-player-name',
  PLAYER_FLAG: 'sa-player-flag',
  PLAYER_AGE: 'sa-player-age',
  PLAYER_AGE_YEARS: 'sa-player-age-years',
  PLAYER_BIRTHDAY: 'sa-player-birthday',
  PLAYER_POSITION: 'sa-player-position',
  PLAYER_CLUB: 'sa-player-club',
  CLUB_ROW: 'sa-club-row',
  CLUB_EMBLEM: 'sa-club-emblem',
  CLUB_NAME: 'sa-club-name',
  CLUB_FLAG: 'sa-club-flag',
  LEAGUE_NAME: 'sa-league-name',
  PLAYER_SCORES: 'sa-player-scores',
  PLAYERS_TABLE: 'sa-players-table',

  // NBA Player patterns
  NBA_PLAYER_RANK: 'sa-nba-player-rank',
  NBA_PLAYER_INFO: 'sa-nba-player-info',
  NBA_PLAYER_LINK: 'sa-nba-player-link',
  NBA_PLAYER_NAME_ROW: 'sa-nba-player-name-row',
  NBA_PLAYER_NAME: 'sa-nba-player-name',
  NBA_PLAYER_FLAG: 'sa-nba-player-flag',
  NBA_PLAYER_AGE: 'sa-nba-player-age',
  NBA_PLAYER_AGE_YEARS: 'sa-nba-player-age-years',
  NBA_PLAYER_BIRTHDAY: 'sa-nba-player-birthday',
  NBA_CLUB_ROW: 'sa-nba-club-row',
  NBA_CLUB_EMBLEM: 'sa-nba-club-emblem',
  NBA_CLUB_NAME: 'sa-nba-club-name',
  NBA_GAME_WEEK_SCORES: 'sa-nba-game-week-scores',
  NBA_GAMES_SCORES: 'sa-nba-games-scores',
  NBA_SORARE_L10_AVERAGE: 'sa-nba-sorare-l10-average',
  NBA_DIFF_ROW: 'sa-nba-diff-row',
  NBA_GAME_WEEK_AVERAGE: 'sa-nba-game-week-average',
  NBA_DIFF_MINUS: 'sa-nba-diff-minus',
  NBA_L10_AVERAGE: 'sa-nba-l10-average',
  NBA_DIFF_EQUALS: 'sa-nba-diff-equals',
  NBA_DIFF_RESULT: 'sa-nba-diff-result',
  NBA_PLAYERS_LIST: 'sa-nba-players-list',
  NBA_PLAYERS_TABLE: 'sa-nba-players-table',

  // Match patterns
  MATCH_SCORE: 'sa-match-score',
  HOME_TEAM: 'sa-home-team',
  SCORE_DISPLAY: 'sa-score-display',
  AWAY_TEAM: 'sa-away-team',
  MATCH_DATE: 'sa-match-date',
  GAME_STATUS: 'sa-game-status',
  SCORE_VALUE: 'sa-score-value',

  // Game patterns
  GAME_WEEK: 'sa-game-week',
  GAME_TYPE: 'sa-game-type',
  DECISIVE_ACTIONS: 'sa-decisive-actions',
  DECISIVE_SCORE: 'sa-decisive-score',
  ALL_AROUND_SCORE: 'sa-all-around-score',

  // Status patterns
  PLAYED_STATUS: 'sa-played-status',
  STARTED_STATUS: 'sa-started-status',
  PLAYED_STATUS_CONTAINER: 'sa-played-status-container',
  BENCH_STATUS: 'sa-bench-status',
  NOT_IN_SQUAD_STATUS: 'sa-not-in-squad-status',
  MINUTES_PLAYED: 'sa-minutes-played',

  // Table patterns
  SCORES_TABLE: 'sa-scores-table',
  NBA_SCORES_TABLE: 'sa-nba-scores-table',

  // Card patterns
  CARD_BONUS: 'sa-card-bonus',
  CARD_BONUS_BREAKDOWN: 'sa-card-bonus-breakdown',
  CARD_BONUS_VALUE: 'sa-card-bonus-value',
  CARD_BONUS_NO_BONUS: 'sa-card-bonus-no-bonus',
  CARD_BONUS_SCARCITY: 'sa-card-bonus-scarcity',
  CARD_BONUS_SCARCITY_LABEL: 'sa-card-bonus-scarcity-label',
  CARD_BONUS_SCARCITY_VALUE: 'sa-card-bonus-scarcity-value',
  CARD_BONUS_SEASON: 'sa-card-bonus-season',
  CARD_BONUS_SEASON_LABEL: 'sa-card-bonus-season-label',
  CARD_BONUS_SEASON_VALUE: 'sa-card-bonus-season-value',
  CARD_BONUS_XP: 'sa-card-bonus-xp',
  CARD_BONUS_XP_LABEL: 'sa-card-bonus-xp-label',
  CARD_BONUS_XP_VALUE: 'sa-card-bonus-xp-value',
  CARD_BONUS_COLLECTION: 'sa-card-bonus-collection',
  CARD_BONUS_COLLECTION_LABEL: 'sa-card-bonus-collection-label',
  CARD_BONUS_COLLECTION_VALUE: 'sa-card-bonus-collection-value',

  // Auction patterns
  AUCTION_CARD_CONTAINER: 'sa-auction-card-container',
  AUCTION_CARD_IMAGE_LINK: 'sa-auction-card-image-link',
  AUCTION_CARD_IMAGE: 'sa-auction-card-image',
  AUCTION_CARD: 'sa-auction-card',
  AUCTION_CARD_BOTTOM: 'sa-auction-card-bottom',
  AUCTION_PRICES_BLOCK: 'sa-auction-prices-block',
  AUCTION_PRICE_LINK: 'sa-auction-price-link',
  AUCTION_PRICE_VALUE: 'sa-auction-price-value',

  // Price block patterns
  PRICE_BLOCK: 'sa-price-block',
  RARITY_NAME: 'sa-rarity-name',
  CLOCK_ICON: 'sa-clock-icon',
  LAST_AUCTION_LINK: 'sa-last-auction-link',
  CART_ICON: 'sa-cart-icon',
  CHEAPEST_PRICE_LINK: 'sa-cheapest-price-link',

  // Icon patterns
  GOOGLE_ICON: 'sa-google-icon',
  U23_ICON: 'sa-u23-icon',
  REWARD_ICON: 'sa-reward-icon',
  TRANSFERMARKT_ICON: 'sa-transfermarkt-icon',
  REFERRAL_ICON: 'sa-referral-icon',
  TWITTER_ICON: 'sa-twitter-icon',

  // Link patterns
  LAST_AUCTION_PRICE_LINK: 'sa-last-auction-price-link',
  BEST_MARKET_PRICE_LINK: 'sa-best-market-price-link',

  // No scores data
  NO_SCORES_DATA: 'sa-no-scores-data',

  // Next games (upcoming fixtures) patterns
  NO_NEXT_GAMES_DATA: 'sa-no-next-games-data',
  NEXT_GAMES_TABLE: 'sa-next-games-table',
  NEXT_GAME_WEEK: 'sa-next-game-week',
  NEXT_GAME_DATE: 'sa-next-game-date',
  NEXT_GAME_COMPETITION: 'sa-next-game-competition',
  NEXT_MATCHUP: 'sa-next-matchup',
  NEXT_HOME_TEAM: 'sa-next-home-team',
  NEXT_AWAY_TEAM: 'sa-next-away-team',
  NEXT_GAME_TYPE: 'sa-next-game-type',
  NEXT_HOME_AWAY: 'sa-next-home-away',

  // Select patterns
  ANTD_SELECT: 'sa-antd-select',
  SELECT_OPTION: 'sa-select-option',
  ANTD_SELECT_OPTION: 'sa-antd-select-option',

  // Club and league patterns
  CLUB_SELECT: 'sa-club-select',
  NBA_CLUB_SELECT: 'sa-nba-club-select',
  LEAGUE_SELECT: 'sa-league-select',

  // Modal patterns
  PLAYED_FILTER_MODAL: 'sa-played-filter-modal',
  PRICES_FILTER_MODAL: 'sa-prices-filter-modal',
  SCORES_FILTER_MODAL: 'sa-scores-filter-modal',
  FILTER_MODAL_CONTENT: 'sa-filter-modal-content',
  FILTER_MODAL_CLOSE: 'sa-filter-modal-close',
  MODAL_CONTENT: 'sa-modal-content',
  COMPLEX_CONTENT: 'sa-complex-content',

  // NBA patterns
  NBA_SCORES: 'sa-nba-scores',
  NBA_PLAYER_ITEM: 'sa-nba-player-item',
  NBA_PLAYER_PROFILE_CARD: 'sa-nba-player-profile-card',
  NBA_SCORES_LIST: 'sa-nba-scores-list',

  // Game week patterns
  GAMEWEEK_SCORES: 'sa-gameweek-scores',

  // Player patterns
  PLAYERS_LIST: 'sa-players-list',
  PLAYER_ITEM: 'sa-player-item',
  PLAYER_PROFILE_CARD: 'sa-player-profile-card',

  // Scores patterns
  SCORES: 'sa-scores',

  // Icon patterns
  TRANSFERMARKT: 'sa-transfermarkt',
  TWITTER: 'sa-twitter',
  GOOGLE: 'sa-google',
  REWARD: 'sa-reward',
  REFERRAL: 'sa-referral',

  // Reward card patterns
  REWARD_CARD: 'sa-reward-card',

  // Filters patterns
  FILTERS: 'sa-filters',
  APPLY_FILTERS_BUTTON: 'sa-apply-filters-button',

  // Selected patterns
  SELECTED_RARITY: 'sa-selected-rarity',
  SELECTED_SCORES_TYPE: 'sa-selected-scores-type',
  SELECTED_SCORES_SORT: 'sa-selected-scores-sort',

  // Manager card patterns
  MANAGER_CARD: 'sa-manager-card',

  // App patterns
  ROUTER_PROVIDER: 'sa-router-provider',
  APP_LAYOUT: 'sa-app-layout',
  APP_HEADER: 'sa-app-header',
  APP_CONTENT: 'sa-app-content',
  OUTLET: 'sa-outlet',

  // Antd patterns
  ANTD_CARD: 'sa-antd-card',
  ANTD_CARD_TITLE: 'sa-antd-card-title',

  // Rarity select patterns
  RARITY_SELECT: 'sa-rarity-select',

  // Icon component patterns
  ICON: 'sa-icon',

  // Data context patterns
  RARITY: 'sa-rarity',
  RESET_FILTERS: 'sa-reset-filters',
  SET_RARITY_SELECT_VALUE: 'sa-set-rarity-select-value',
  SET_RARITY_SELECT_VALUE_RARE: 'sa-set-rarity-select-value-rare',
  CHILD: 'sa-child',

  // Dummy patterns
  DUMMY: 'sa-dummy',

  // Chart patterns
  CHART_LOADING: 'sa-chart-loading',
  LINE_CHART: 'sa-line-chart',
  X_AXIS: 'sa-x-axis',
  CARTESIAN_GRID: 'sa-cartesian-grid',
  TOOLTIP: 'sa-tooltip',
  LEGEND: 'sa-legend',
  LINE: 'sa-line',
  Y_AXIS: 'sa-y-axis',

  // Table patterns
  TABLE: 'sa-table',
  TABLE_HEADER: 'sa-table-header',
  TABLE_BODY: 'sa-table-body',
  TABLE_ROW: 'sa-table-row',
  TABLE_CELL: 'sa-table-cell',
  TABLE_COLUMN: 'sa-table-column',

  // Pagination patterns
  PAGINATION: 'sa-pagination',
  PAGE_BUTTON: 'sa-page-button',

  // Tag patterns
  TAG: 'sa-tag',
  ANTD_TAG: 'sa-antd-tag',

  // Tooltip patterns
  ANTD_TOOLTIP: 'sa-antd-tooltip',
  TOOLTIP_CONTENT: 'sa-tooltip-content',

  // Avatar patterns
  ANTD_AVATAR: 'sa-antd-avatar',

  // Time and badges patterns
  TIME_AND_BADGES: 'sa-time-and-badges',

  // Score patterns
  SCORE: 'sa-score',
  SCORE_COMPONENT: 'sa-score-component',

  // Flag icon patterns
  FLAG_ICON: 'sa-flag-icon',

  // Modal patterns
  MODAL: 'sa-modal',
  MODAL_TITLE: 'sa-modal-title',

  // Sorare connection (header)
  CONNECT_SORARE: 'sa-connect-sorare',
  SESSION_MENU: 'sa-session-menu',
  SESSION_AVATAR: 'sa-session-avatar',

  // Slider patterns
  SLIDER_INPUT: 'sa-slider-input',
  MARK_0: 'sa-mark-0',
  MARK_25: 'sa-mark-25',
  MARK_50: 'sa-mark-50',
  MARK_75: 'sa-mark-75',
  MARK_100: 'sa-mark-100',
} as const;
